/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkupV2State
 */
export interface MarkupV2State {
    /**
     * 
     * @type {string}
     * @memberof MarkupV2State
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2State
     */
    disabled?: boolean;
}

export function MarkupV2StateFromJSON(json: any): MarkupV2State {
    return MarkupV2StateFromJSONTyped(json, false);
}

export function MarkupV2StateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2State {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function MarkupV2StateToJSON(value?: MarkupV2State | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


